function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

export { eachAxis };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/projection/utils/each-axis.mjs
// module id = A9vs
// module chunks = 0